import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { CommonErrorCode, UserErrorCode } from '~commonInfra/utils/ErrorCodes';

import { Messages } from '../../codegen/Localize';
import { L10n } from '../../commonInfra/L10n/L10n';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export enum UserSettingsNotificationType {
  UpdateUserDisplayName,
  UpdateUserEmail,
  ChangePassword,
  ChangeLanguage,
  ChangeLocale,
  ChangeTimeZone
}

export interface UserSettingsNotificationParams {
  result: IResult;
  userSettingsNotificationType: UserSettingsNotificationType;
  username: string;
  displayName?: string;
  email?: string;
}

export namespace UserSettingsNotification {

  export function notify(params: UserSettingsNotificationParams){

      if (!!params.result.errors && params.result.errors.length > 0) {
        const errorMsg: string = errorMessageFor(params.result.errors[0], params);
        ToasterService.instance.pop({ type: ToastType.Error, text: errorMsg });
      } else {
        const successMsg = successMessageFor(params);
        ToasterService.instance.pop({ type: ToastType.Success, text: successMsg});
      }
  }

  function successMessageFor(params: UserSettingsNotificationParams): string {
    switch (params.userSettingsNotificationType) {
      case UserSettingsNotificationType.UpdateUserDisplayName:
        return Messages.updateUserDisplayNameSuccess({ USER_NAME: L10n.elideIfLong(params.username), DISPLAY_NAME: L10n.elideIfLong(params.displayName)});
      case UserSettingsNotificationType.UpdateUserEmail:
        return Messages.updateUserEmailSuccess({ USER_NAME: L10n.elideIfLong(params.username), EMAIL: params.email });
      case UserSettingsNotificationType.ChangePassword:
        return Messages.changePasswordSuccess({ USER_NAME: L10n.elideIfLong(params.username) });
      case UserSettingsNotificationType.ChangeLanguage:
        return Messages.changeLanguageSuccess({ USER_NAME: L10n.elideIfLong(params.username) });
      case UserSettingsNotificationType.ChangeLocale:
        return Messages.changeLocaleSuccess({ USER_NAME: L10n.elideIfLong(params.username) });
      case UserSettingsNotificationType.ChangeTimeZone:
        return Messages.changeTimeZoneSuccess({ USER_NAME: L10n.elideIfLong(params.username)});
      default:
        return '';
    }
  }

  function errorMessageFor(error: IError, params: UserSettingsNotificationParams): string {
    switch (error.code) {
      case CommonErrorCode.SystemUserNotFound:
        return Messages.errorSystemUserNotFound({ USER_NAME: L10n.elideIfLong(params.username) });
      case UserErrorCode.UserInvalidPassword:
        return Messages.errorUserOldPasswordIncorrect();
      case UserErrorCode.UserPasswordNotRespectingPolicies:
        return Messages.errorUserPasswordNotRespectingPolicies();
      case UserErrorCode.LoginAttemptRejected:
        return Messages.errorAccountIsInLockoutPeriod();
      case UserErrorCode.PasswordNotUpdated:
        return Messages.newPasswordIsSameAsOldPasswordError();
      default:
        return Messages.errorUnknown();
    }
  }

  export type UserSettingsNotification = typeof UserSettingsNotification;
}
